import { usersModule } from '@/store/database/usersModule';
import { createNewContext, contextsModule } from '@/store/database/contextsModule';
import { pagesModule } from '@/store/database/pagesModule';
import axios from 'axios';
import fb from '@/firebaseConfig';
import router from '@/router';

import { ref, computed, watch } from '@vue/composition-api';
import { collection, getDoc, setDoc, doc, getFirestore } from 'firebase/firestore';
import {
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  signOut
} from 'firebase/auth';

import { guideTemplate } from '@/store/database/contextTemplates';

export const currentUserId = ref(null);

export const currentUserPermissions = ref([]);

export const isUser = computed(() => !!currentUserId.value);

export const setCurrentUserId = userId => (currentUserId.value = userId);

export const userModule = computed(() => {
  console.log('user module update');
  if (currentUserId.value) {
    return usersModule.doc(currentUserId.value);
  } else {
    return {};
  }
});

const userData = computed(() => {
  console.log('user module update');
  if (currentUserId.value && usersModule.doc(currentUserId.value).data) {
    return usersModule.doc(currentUserId.value).data;
  } else {
    return {};
  }
});

const refreshUserToken = computed(() => {
  if (userData.value.refreshToken) {
    console.log('need to refresh token');
    return true;
  } else {
    return false;
  }
});

document.user = userModule;

const getUserPermissions = (forceRefresh = false) => {
  const auth = getAuth();
  auth.currentUser.getIdTokenResult(forceRefresh).then(r => {
    console.log(r);
    currentUserPermissions.value = r.claims.contextIds;
  });
};

watch(refreshUserToken, newValue => {
  //  watch for refreshToken to be set to true
  //  if true, get a new token from firebase
  //  this means a user was added or removed to a context
  console.log('user refresh token status changed', newValue);
  if (newValue) {
    console.log('update user auth token');
    //  we need to refresh our log in token
    getUserPermissions(true);
    // const auth = getAuth();
    // auth.currentUser.getIdTokenResult(true).then(r => console.log(r));
    //  we need to update user so refreshToken is false
    userModule.value.merge({ refreshToken: false });
  }
});

export const avatar = computed(() => {
  return userModule.value && userModule.value.data ? userModule.value.data.profile.avatar : '';
});

export const subscribeToUser = async userId => {
  setCurrentUserId(userId);
  // console.log('subscribeToUser');
  const userModule = usersModule.doc(userId);
  console.log('subscribeToUser', userModule);
  await userModule.fetch();
  if (userModule.data) {
    getUserPermissions();
    userModule.stream();
    return true;
  } else {
    console.log('could not find user');
    return false;
  }
};

export const unsubscribeToUser = () => {
  usersModule.closeAllStreams();
  setCurrentUserId(null);
};
// export const updateProfile = data => {
//   return new Promise((resolve, reject) => {
//     userModule.value.merge({ data })
//       .then(() => {
//         resolve();
//       })
//       .catch(err => {
//         console.log(err);
//         reject(err.reason);
//       });
//   });
// }

export const createAccountPassword = async ({ name, email, password, inviteId = false }) => {
  const auth = getAuth();
  await createUserWithEmailAndPassword(auth, email, password);
  console.log('created user with pw');
  // Updates the user attributes:
  await updateProfile(auth.currentUser, {
    displayName: name
  });

  const currentUser = auth.currentUser;

  // commit('setCurrentUser', currentUser);
  setCurrentUserId(currentUser.uid);
  // dispatch('track/setAlias', { userId: currentUser.uid }, { root: true });
  // dispatch('track/identify', { userId: currentUser.uid }, { root: true });
  // dispatch('track/trackEvent', { action: 'Sign up with password' }, { root: true });
  console.log('run create new user');
  createNewUser({ user: currentUser });
  return;
};

export const signInPassword = ({ email, password }) => {
  return new Promise((resolve, reject) => {
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then(result => {
        console.log(result);
        var user = result.user;
        console.log(user);
        setCurrentUserId(user.uid);
        // dispatch('track/identify', { userId: result.user.uid }, { root: true });
        resolve(true);
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        reject(error);
        // ...
      });
  });
};

export const signInWithGoogle = ({ inviteId = false }) => {
  return new Promise((resolve, reject) => {
    var provider = new GoogleAuthProvider();
    const auth = getAuth();
    signInWithPopup(auth, provider)
      .then(function(result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        // var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;
        console.log(user);

        // commit('setCurrentUser', user);

        //  Check if user exists in db
        subscribeToUser(user.uid)
          .then(userExists => {
            if (userExists) {
              resolve(true);
            } else {
              createNewUser({ user, inviteId });
            }
            // exists, identify user to analytics
            // Vue.prototype.$ma.identify({ userId: user.user.uid });
            // dispatch('track/identify', { userId: user.uid }, { root: true });
            // if (router.currentRoute.name == 'landingPage') {
            //   router.push({ name: 'dashboard' });
            // }
            // resolve(true);
          })
          .catch(() => {
            //  user does not exist yet, create it
            //  Set mulianalytics identity
            // dispatch('track/setAlias', { userId: user.uid }, { root: true });
            // dispatch('track/identify', { userId: user.uid }, { root: true });
            // Vue.prototype.$ma.setAlias({ userId: user.user.uid });
            // Vue.prototype.$ma.identify({ userId: user.user.uid });

            //  Create user document
            createNewUser({ user, inviteId });
          });
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The AuthCredential type that was used.
        var credential = error.credential;
        reject(error);
      });
  });
};

export const createNewUser = async ({ user }) => {
  //  check if user exists
  console.log('check if user', user);
  const db = getFirestore();
  const userRef = doc(collection(db, 'users'), user.uid);
  const userDoc = await getDoc(userRef);
  if (userDoc.exists()) {
    console.log('userDoc exits', userDoc);
    subscribeToUser(user.uid);
    return;
  } else {
    console.log('set user doc', user);
    setDoc(userRef, {
      emails: [
        {
          address: user.email,
          verified: true //user.emailVerified
        }
      ],
      profile: {
        name: user.displayName,
        avatar: user.photoURL
          ? user.photoURL
          : 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y'
      },
      collaborators: [],
      createdAt: new Date(),
      active: true,
      user: true,
      handles: {
        twitter: false,
        slack: false
      }
    })
      .then(async () => {
        try {
          console.log('doc reated, subscribe to user');
          subscribeToUser(user.uid);
          //create the accessSummary document
          const url = fb.paths.function + 'createNewAccessSummary';
          await axios.post(url, {
            userId: user.uid
          });
          //  create first context
          await createNewContext({ text: 'Personal', template: guideTemplate });
          console.log('all done, go to context');
          router.push({ name: 'megaContext' });
        } catch (e) {
          console.log(e);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};

export const resetPassword = email => {
  // return new Promise((resolve, reject) => {
  //   fb.auth
  //     .sendPasswordResetEmail(email)
  //     .then(() => {
  //       resolve();
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       reject(err.reason);
  //     });
  // });
};

export const updateUserPermissions = userIds => {
  const url = fb.paths.function + 'updateUserCustomClaims';
  axios.post(url, {
    userIds
  });
};

export const logout = () => {
  const auth = getAuth();
  signOut(auth)
    .then(() => {
      setCurrentUserId(null);
      // Vue.prototype.$ma.trackEvent({ action: 'User Logged Out' });
      // Vue.prototype.$ma.reset();
      console.log('unsubscribe from all');
      usersModule.closeAllStreams();
      contextsModule.closeAllStreams();
      pagesModule.closeAllStreams();
      console.log('router push');
      router.push('/');
    })
    .catch(err => {
      console.log(err);
    });
};
